import script from "./RequestTraining.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestTraining.vue?vue&type=script&setup=true&lang=js"

import "./RequestTraining.vue?vue&type=style&index=0&id=a843ede2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a843ede2"]])

export default __exports__